
<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">{{ linkData ? 'settings' : 'add_circle' }}</v-icon>
            {{ linkData ? 'Edit' : 'Add' }}  Link
          </span>
        </v-card-title>
        <v-card-text>
          <v-form ref="link_form" data-vv-scope="link_form" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="form.from_url"
                  label="From URL*"
                  v-validate="'required|url'"
                  data-vv-name="link_form.from_url"
                  :error-messages="errors.collect('link_form.from_url')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.target_url"
                  label="Target URL*"
                  v-validate="'required|url'"
                  data-vv-name="link_form.target_url"
                  :error-messages="errors.collect('link_form.target_url')"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="form.anchor_text"
                  ref="anchor_text"
                  label="Aanchor text*"
                  :rules="anchorTextRules"
                  :disabled="form.image_link"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  v-model="form.image_link"
                  ref="image_link"
                  color="primary"
                  label="Image Link"
                ></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-checkbox
                  v-model="form.follow"
                  color="primary"
                  label="rel=follow"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12>
                <v-checkbox
                  v-model="form.enabled"
                  color="primary"
                  label="Enable"
                ></v-checkbox>
              </v-flex>
              <v-flex xs12 mb-3>
                <v-subheader><b>Additional info</b></v-subheader>
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs6 pr-3>
                <v-menu
                  ref="menuDateFrom"
                  :close-on-content-click="false"
                  v-model="menuDateFrom"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="form.additional_info.added_date"
                    label="Added date"
                    required
                    clearable
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="form.additional_info.added_date"
                    @change="changeDateFrom()"
                    locale="en"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pl-3>
                <v-menu
                  ref="menuDateTo"
                  :close-on-content-click="false"
                  v-model="menuDateTo"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="form.additional_info.expires_date"
                    label="Expires date"
                    required
                    clearable
                  ></v-text-field>
                  <v-date-picker
                    ref="picker"
                    v-model="form.additional_info.expires_date"
                    @change="changeDateTo()"
                    locale="en"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs6 pr-3>
                <v-text-field
                  v-model="form.additional_info.cost"
                  label="Cost"
                  v-validate="'decimal:2|max_value:10000000'"
                  data-vv-name="link_form.cost"
                  :error-messages="errors.collect('link_form.cost')"
                  min=0
                  max=10000000
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pl-3>
                <v-select
                  v-model="form.additional_info.currency"
                  :items="currency"
                  label="Currency"
                ></v-select>
              </v-flex>
              <v-flex xs6 pr-3>
                <v-text-field
                  v-model="form.additional_info.contact_name"
                  label="Contact name"
                  v-validate="'max:100'"
                  data-vv-name="link_form.contact_name"
                  :error-messages="errors.collect('link_form.contact_name')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 pl-3>
                <v-text-field
                  v-model="form.additional_info.contact_email"
                  label="Contact email"
                  v-validate="'email|max:100'"
                  data-vv-name="link_form.contact_email"
                  :error-messages="errors.collect('link_form.contact_email')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="form.additional_info.note"
                  label="Comments"
                  rows="3"
                  v-validate="'max:1000'"
                  data-vv-name="link_form.note"
                  :error-messages="errors.collect('link_form.note')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveLinks()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'LinkModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['linkDialog', 'linkData', 'loading'],
  data () {
    return {
      dialog: this.linkDialog,
      form: {
        from_url: this.linkData ? this.linkData.from_url : '',
        target_url: this.linkData ? this.linkData.target_url : '',
        enabled: this.linkData ? this.linkData.enabled : true,
        image_link: this.linkData ? this.linkData.image_link : false,
        anchor_text: this.linkData ? this.linkData.anchor_text : '',
        follow: this.linkData ? this.linkData.follow : true,
        additional_info: {
          added_date: this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.added_date : '',
          expires_date: this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.expires_date : '',
          cost: this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.cost : 0,
          currency: this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.currency : 'ILS',
          contact_name: this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.contact_name : '',
          contact_email: this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.contact_email : '',
          note: this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.note : ''
        }
      },
      menuDateFrom: false,
      menuDateTo: false,
      currency: [
        { text: '₪', value: 'ILS' },
        { text: '$', value: 'USD' },
        { text: '€', value: 'GBP' },
        { text: '£', value: 'EUR' }
      ],
      anchorTextRules: [
        v => (this.form.image_link || !!v) || 'Anchor text is required'
      ],
      dictionary: {
        en: {
          custom: {
            'link_form.from_url': {
              required: 'Please add From URL',
              url: 'Only URL'
            },
            'link_form.target_url': {
              required: 'Please add Target URL',
              url: 'Only URL'
            },
            'link_form.contact_email': {
              email: 'Only email',
              max: 'Max length 100 symbols'
            },
            'link_form.contact_name': {
              max: 'Max length 100 symbols'
            },
            'link_form.note': {
              max: 'Max length 1000 symbols'
            },
            'link_form.cost': {
              max_value: 'Cost should be less then 10000000',
              decimal: 'Only numbers'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    linkDialog: {
      handler () {
        this.dialog = this.linkDialog
        if (this.dialog && !this.linkData) {
          this.clearForm()
        }
      }
    },
    'form.image_link': {
      handler () {
        this.$refs.link_form.validate()
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('linkDialog', this.dialog)
      }
    },
    linkData: {
      handler () {
        this.form.from_url = this.linkData ? this.linkData.from_url : ''
        this.form.target_url = this.linkData ? this.linkData.target_url : ''
        this.form.enabled = this.linkData ? this.linkData.enabled : true
        this.form.image_link = this.linkData ? this.linkData.image_link : false
        this.form.anchor_text = this.linkData ? this.linkData.anchor_text : ''
        this.form.follow = this.linkData ? this.linkData.follow : true
        this.form.additional_info.added_date = this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.added_date : ''
        this.form.additional_info.expires_date = this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.expires_date : ''
        this.form.additional_info.cost = this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.cost : 0
        this.form.additional_info.currency = this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.currency : 'ILS'
        this.form.additional_info.contact_name = this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.contact_name : ''
        this.form.additional_info.contact_email = this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.contact_email : ''
        this.form.additional_info.note = this.linkData && Object.keys(this.linkData.additional_info).length !== 0 ? this.linkData.additional_info.note : ''
      }
    }
  },
  methods: {
    saveLinks () {
      let valid = false
      if (this.$refs.link_form.validate()) valid = true
      this.$validator.validateAll('link_form').then(res => {
        if (res && valid) {
          this.prepareFormData()

          this.$parent.$emit('loading', true)
          this.linkData ? this.editLink() : this.addLink()
        }
      })
    },
    addLink () {
      this.$store.dispatch('ADD_LINKS', [this.form]).then(res => {
        this.$toasted.show('Link was successfully added')
        this.$parent.$emit('loading', false)
        this.$parent.$emit('updateLinksList')
        this.closeModal()
      }, err => {
        console.log('login error', err)
        this.$parent.$emit('loading', false)
        this.$toasted.show('ADD_LINKS ERROR: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    editLink () {
      this.$store.dispatch('EDIT_LINK', { linkId: this.linkData.id, link: this.form }).then(res => {
        this.$toasted.show('Link was successfully edited')
        this.$parent.$emit('loading', false)
        this.$parent.$emit('updateLinksList')
        this.closeModal()
      }, err => {
        console.log('login error', err)
        this.$parent.$emit('loading', false)
        this.$toasted.show('EDIT_LINK ERROR: ' + this.$services.getApiError(err), { type: 'error' })
      })
    },
    prepareFormData () {
      this.form.follow = parseInt(this.form.follow)
      this.form.additional_info.cost = parseFloat(this.form.additional_info.cost)
      this.form.follow = this.form.follow ? 1 : 0
      this.form.anchor_text = this.form.image_link ? '' : this.form.anchor_text
    },
    closeModal () {
      this.dialog = false
      this.clearForm()
    },
    clearForm () {
      this.form = {
        from_url: '',
        target_url: '',
        enabled: true,
        image_link: false,
        anchor_text: '',
        follow: true,
        additional_info: {
          added_date: '',
          expires_date: '',
          currency: 'ILS',
          cost: 0,
          contact_name: '',
          contact_email: '',
          note: ''
        }
      }

      setTimeout(() => {
        this.$validator.errors.clear('link_form')
        this.$refs.link_form.resetValidation()
      }, 200)
    },
    changeDateFrom (date) {
      this.$refs.menuDateFrom.save(date)
    },
    changeDateTo (date) {
      this.$refs.menuDateTo.save(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/link-modal/LinkModal.vue